import { ocapiClient } from '../../../api-clients/ocapi/client';
/**
 * Gets an Apple Wallet pass for a specified Journey.
 * Apple Wallet Passes are files with the PKPass file type. Opening the file will prompt the patron to add the pass to their Apple Wallet.
 */
export const loadAppleWalletPassForJourney = async (journeyId) => {
    return ocapiClient.instance.v1.journeys.thirdPartyPasses.getAppleWalletPass(journeyId);
};
